import {keyValueStore} from '../../../libs/shared/core/src/services/storage/storage';

/*
 * Constants.
 */

const identityKey = 'front-user';

/*
 * Identity.
 */

// The last known user ID.
export function getIdentity() {
  const identityValue = keyValueStore.read(identityKey);

  if (identityValue === undefined) {
    return undefined;
  }

  const userId = Number(identityValue);

  if (!Number.isFinite(userId)) {
    return undefined;
  }

  return userId;
}

export function setIdentity(userId: number) {
  return keyValueStore.set(identityKey, userId.toString());
}
